<template>
    <ies-form-field :field="field">
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    :items="selectableActivities"
                    item-text="title"
                    item-value="facility_key"
                    v-model="facilityKeys"
                    multiple
                    chips
                    deletable-chips
                    outlined
                    dense
                ></v-autocomplete>
            </v-col>
            <input type="hidden" :name="this.field.fieldName" :value="field.value">
        </v-row>
    </ies-form-field>
</template>

<script>
    export default {
        name: 'ies-input-trip-activities',
        props: ['field', 'recordData', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                tripKey: 0,
                facilityKeys: [],
                selectableActivities: [],
            }
        },

        created: function() {
            this.tripKey = this.getTripKeyFromUrl();
            if (this.tripKey > 0) {
                this.getActivities();
            }
            this.getSelectableActivities();
            this.syncFieldValue();
        },

        methods: {
            getTripKeyFromUrl: function() {
                if (!this.page || !this.page.edit_url) {
                    return 0;
                }
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index) {
                    if (bit == '{Trip.trip_key}') {
                        foundIndex = index;
                    }
                });
                if (foundIndex === null) {
                    return 0;
                }
                var urlBits = location.pathname.split('/').splice(1);
                return parseInt(urlBits[foundIndex]) || 0;
            },

            getSelectableActivities: function() {
                // facilityCategory: 4 is Facility::ACTIVITY (app/Models/Facility.php)
                axios.get('/api/facilities', { params: { facilityCategory: 4 } }).then((response) => {
                    this.selectableActivities = response.data;
                });
            },

            getActivities: function() {
                axios.get('/api/trip-activities/' + this.tripKey).then((response) => {
                    if (response.data.activities && response.data.activities.length) {
                        this.facilityKeys = response.data.activities.map(function(item) {
                            return item.facility_key;
                        });
                        this.syncFieldValue();
                    }
                });
            },

            syncFieldValue: function() {
                this.field.value = {
                    trip_key:     this.tripKey,
                    facilityKeys: this.facilityKeys,
                };
            },
        },

        watch: {
            facilityKeys: {
                handler: function() {
                    this.syncFieldValue();
                },
                deep: true,
            },
        },
    }
</script>
